type BreadcrumbSegment = {
  title: string;
  url?: string;
};

const getFormattedSegmentTitle = (segment: string) =>
  decodeURIComponent(segment)
    .split(/[-_]+/g)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const getHeroBreadcrumbSegments = (
  pathname: string | null,
  pageTitle?: string
): BreadcrumbSegment[] => {
  if (!pathname) return [];

  const cleanPath = pathname.split("?")[0].split("#")[0];
  const pathSegments = cleanPath.split("/").filter(Boolean);

  if (!pathSegments.length) {
    return [];
  }

  return pathSegments.map((segment, index) => {
    const isLast = index === pathSegments.length - 1;
    const path = `/${pathSegments.slice(0, index + 1).join("/")}/`;

    if (isLast) {
      return {
        title: pageTitle || getFormattedSegmentTitle(segment),
      };
    }

    return {
      title: getFormattedSegmentTitle(segment),
      url: path,
    };
  });
};
